export const KETCH_CONSENT_UPDATE = 'ketch:consent-update'
